import Vue, { ComponentOptions, CreateElement, VNode } from "vue";
import AppPagination from "~shared/components/AppPagination.vue";

export interface EntityListPaginationComponent extends Vue {
  page: number;
  total: number;
}

export class EntityListPaginationBuilder {
  private buildPagination(h: CreateElement, component: EntityListPaginationComponent): VNode {
    return h(AppPagination, {
      attrs: {
        page: component.page,
        total: component.total,
      },
      on: {
        change(newPage) {
          component.$emit("onPageChanged", newPage);
        },
      },
    });
  }

  public build(): ComponentOptions<EntityListPaginationComponent> {
    const $ = this;

    return {
      props: {
        page: {
          type: Number,
          required: true,
        },
        total: {
          type: Number,
          required: true,
        },
      },
      render(this: EntityListPaginationComponent, h: CreateElement): VNode {
        return h(
          "div",
          {
            staticClass: "entity-list-pagination",
          },
          [$.buildPagination(h, this)]
        );
      },
    };
  }
}
